<template>
  <v-app-bar app density="prominent" color="#DC143C" class="toolbar">
    <v-toolbar-items class="items">
      <v-btn
        icon="mdi-arrow-left"
        variant="plain"
        v-if="!isHome"
        @click="$router.go(-1)"
      >
      </v-btn>
      <v-btn icon="mdi-home" link to="/home" variant="plain"> </v-btn>
    </v-toolbar-items>
    <v-toolbar-title class="flex text-center"
      ><img :src="require('../assets/mrshmeklogo.png')" class="logo" alt="MRShmek" />
    </v-toolbar-title>
    <v-toolbar-items class="contact">
      <v-btn link to="/contact" variant="plain"  size="large">CONTACT</v-btn>
    </v-toolbar-items>
  </v-app-bar>
</template>

<script>
export default {
  computed: {
    isHome() {
      return this.$route.path.includes("home");
    },
  },
};
</script>

<style scoped>
.contact{
  position: absolute;
  right: 0; /* To appear on right side */
  height: 50px;
  width: 110px;
}
.logo {
  position: absolute;
  width: 160px;
  margin: 0 auto;
  left: 0;
  right: 0;
  bottom: 0;
  padding-bottom: 3px;
}
.toolbar {
  top: 0;
}
.items {
  position: absolute;
  height: 50px;
}
</style>
